export default __webpack_public_path__ + "static/media/undone.54dd674c.png";